import { useMemo, useRef } from 'react'
import { useGesture } from '@use-gesture/react'
import { Vector2 } from 'three'

import { useLayoutStore } from '@/store/layout'

export default function usePointer() {
  const delta = useMemo(() => new Vector2(), [])
  const delta11 = useMemo(() => new Vector2(), [])
  const pointer = useMemo(() => new Vector2(), [])
  const pointer01 = useMemo(() => new Vector2(), [])
  const pointer11 = useMemo(() => new Vector2(), [])
  const lastPointer = useMemo(() => new Vector2(), [])
  const lastPointer01 = useMemo(() => new Vector2(), [])
  const touching = useRef(false)

  const updatePointer = (event: PointerEvent) => {
    const x = event.clientX
    const y = event.clientY
    pointer.set(x, y)
    pointer01.set(x / window.innerWidth, 1 - y / window.innerHeight)
    pointer11.copy(pointer01).multiplyScalar(2).subScalar(1)
  }

  const updateDelta = () => {
    delta.copy(pointer).sub(lastPointer)
    delta11.copy(pointer01).sub(lastPointer01)
  }

  const updateLastPointer = () => {
    lastPointer.copy(pointer)
    lastPointer01.copy(pointer01)
  }

  const updateLockDirection = () => {
    if (!touching.current) return
    const layoutStore = useLayoutStore.getState()
    if (!layoutStore.scrollDirLocked) {
      const absX = Math.abs(delta.x)
      const absY = Math.abs(delta.y)
      if (absX > absY) {
        layoutStore.setState({ scrollDirLocked: 'x' })
      } else if (absY > absX) {
        layoutStore.setState({ scrollDirLocked: 'y' })
      } else {
        layoutStore.setState({ scrollDirLocked: null })
      }
    }
  }

  useGesture(
    {
      onPointerDown: ({ event }) => {
        touching.current = true
        updatePointer(event)
        updateLastPointer()
        updateDelta()
      },
      onPointerMove: ({ event }) => {
        updatePointer(event)
        updateDelta()
        updateLastPointer()
        updateLockDirection()
      },
      onPointerUp: ({ event }) => {
        updatePointer(event)
        updateDelta()
        updateLastPointer()
        touching.current = false
        useLayoutStore.getState().setState({ scrollDirLocked: null })
      }
    },
    {
      target: document.body,
      eventOptions: {
        passive: false
      }
    }
  )

  return {
    delta11,
    touching
  }
}
